import { makeStyles, shorthands } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

const FULLSCREEN_DIALOG_WIDTH = "95vw";
const FULLSCREEN_DIALOG_HEIGHT = "95vh";

export const usePagedImagePreviewStyles = makeStyles({
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: "600px",
  },
  carouselContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    gap: designTokens.spacing[4],
  },
  imageWrapper: {
    position: "relative",
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: projectIqTokens.bg2,
    ...shorthands.borderRadius(designTokens.borderRadius.lg),
    overflow: "hidden",
    minHeight: "400px",
  },
  image: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
  },
  dialogSurface: {
    inlineSize: FULLSCREEN_DIALOG_WIDTH,
    maxInlineSize: "none",
    blockSize: FULLSCREEN_DIALOG_HEIGHT,
    maxBlockSize: "none",
  },
  fullscreenImageWrapper: {
    position: "relative",
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: projectIqTokens.bg2,
    ...shorthands.borderRadius(designTokens.borderRadius.lg),
    overflow: "hidden",
    minHeight: 0,
  },
  fullscreenImage: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
  },
  fullscreenContent: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    gap: designTokens.spacing[4],
    minHeight: 0,
    height: "100%",
  },
  fullscreenHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  fullscreenTitle: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.medium,
    color: projectIqTokens.muted,
  },
  imageLoadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: designTokens.overlay.light,
    zIndex: 10,
  },
  controls: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: designTokens.spacing[3],
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    backgroundColor: projectIqTokens.card,
    ...shorthands.borderRadius(designTokens.borderRadius.md),
    boxShadow: projectIqTokens.shadowSm,
  },
  pageCounter: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.ink2,
    whiteSpace: "nowrap",
    minWidth: "120px",
    textAlign: "center",
  },
  processingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    minHeight: "600px",
  },
  errorContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    gap: designTokens.spacing[3],
    minHeight: "600px",
    padding: designTokens.spacing[6],
    textAlign: "center",
    color: projectIqTokens.muted,
  },
  errorHeading: {
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.ink,
  },
  errorBody: {
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.ink3,
    maxWidth: "400px",
  },
});
